<template>
  <div>
    <PageHeader>
      <template v-slot:header>役職情報設定</template>
      <template v-slot:annotation>
        役職の一覧を表示します。情報を編集する場合は、データをクリックして操作を行ってください。
      </template>
    </PageHeader>

    <v-row>
      <v-col cols="6" sm="6" md="4" lg="2">
        <Button @click="onClickPositionEditOpen(null)" color="primary"
          >新規追加</Button
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-2"
          @click:row="onClickPositionEditOpen"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="役職情報は見つかりませんでした。新規追加ボタンより役職を設定してください。"
        />
      </v-col>
    </v-row>

    <DialogMessage ref="dialog" />

    <Edit ref="edit" @edit="editPositionfInfo"> </Edit>
  </div>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import Edit from './PositionEditDialog.vue';
import message from '../../../message.js';
import { getSessionStorageItem } from '../../../common.js';
export default {
  components: {
    Edit,
  },
  data() {
    return {
      // 変数宣言
      showContent: false,
      loading: false,
      searchKey: '',
      confirm: false,

      // パラメータ取得
      organizationName: '',
      loginName: '',
      dispPosition: '',
      sessionId: '',
      items: [],

      headers: [
        {
          text: '表示順',
          align: 'left',
          value: 'SHOW_ORDER',
          width: '15%',
        },
        {
          text: '役職名',
          align: 'left',
          value: 'POSITION_NAME',
          width: '20%',
        },
      ],
    };
  },
  created() {
    // 役職情報取得
    this.get_position();
  },

  methods: {
    onClickPositionEditOpen(item) {
      // 役職情報編集画面を表示
      if (item == null) {
        this.$refs.edit.open(null, { color: 'red' });
      } else {
        this.$refs.edit.open(item, { color: 'red' });
      }
    },
    editPositionfInfo() {
      // 役職情報取得
      this.get_position();
    },
    async get_position() {
      this.loading = true;
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/position/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 役職データ取得
          vm.items = response.data;
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_POSITION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
  },
};
</script>
